$(document).ready(function (params) {

    var isBooking = false;
    var slectType = null;

    $(document).on("click", "#wear-options .design-item", function () {
        $("#wear-options .design-item").removeClass("selected"),
        $("#design-options").html('');
        $(this).addClass("selected");
        slectType = $(this).data('value');
        if(slectType != 'gemstone'){
            $('.main-ev-selection').show(); 
            if(slectType == 'ring'){ 
                $('#ev_metal_1').show();
                $('#ev_metal_2').hide();
                $('.ev_ring').show();
            }
            if(slectType == 'pendant'){ 
                $('#ev_metal_1').hide();
                $('#ev_metal_2').show();
                $('.ev_ring').hide();
            }
            isBooking = true;
            setTimeout(() => {
                $('.ev-select-rp').hide();
            }, 500);
        } else {
            isBooking = false;
            $('.main-ev-selection').hide();
            $('.ev-select-rp').hide();
        }
    });

    $(document).on('click', '#ev_metal_1', function(){
        viewDesign('ring', $(this).val());
    });

    $(document).on('click', '#ev_metal_2', function(){
        viewDesign('pendant', $(this).val());
    });

    function viewDesign(type, metalType){
        let url = window.location.href;
        let slug = url.split('/products/')[1]?.split('/')[0] || '';
        let firstTwoWords = slug.split('-').slice(0, 2).join('-');
        const productSlug = firstTwoWords+'-'+type+'-'+metalType;
        console.log(productSlug);
        updateDesigns(productSlug);
    }
 
    $(document).on("click", ".evproduct .design-item", function (params2) {
        $(".evproduct .design-item").removeClass("selected"),
        $(this).addClass("selected");
    });

    function updateDesigns(productHandle, gemName = '') { 
        const $designOptions = $("#design-options"); 
        $.ajax({
            url: `/products/${productHandle}?view=design-options-html`,
            type: "GET",
            success: function (response) {
                const tempDiv = document.createElement("div");
                tempDiv.innerHTML = response;  
                $designOptions.html(tempDiv.innerHTML);
                $designOptions.show();
            }, error: function (xhr, status, error) {
                const tempDiv = document.createElement("div");
                tempDiv.innerHTML = '<p class="option-label">Design</p><span class="ev-message">This Metal is Not Available</span>';
                $designOptions.html('');
                $designOptions.html(tempDiv.innerHTML);
                $designOptions.show();
                console.error("Error loading design options:", error);
            },
        });
    }

    $(document).on("click", '#ev_submit_cart', function(){
    //   $(document).on("click", 'button[name="add"]', function(e){

   
        
        const selectedRing = $(".evproduct .design-item.selected");
        const variationId = selectedRing.attr('data-var-id');
        const mainVariation = $('.product-variant-id').val();
        var items = []; 
        if(mainVariation != undefined && mainVariation != null){
            items.push({
                id: parseInt(mainVariation),
                quantity: 1,
            });
        }
        if(isBooking){  
            if(variationId != undefined && variationId != null){
                if(slectType == 'ring' && $('#ev_ring_size').val() == null){
                    alert('Please select the ring size');
                    return false;
                }
                var pr = null;
                if(slectType == 'ring'){
                    pr = {
                        "Ring Size System": $('#ev_ring_system').val(),
                        "Ring Size": $('#ev_ring_size').val(), 
                        "Gemstone": $('.product__title h1').text()
                    }
                } else {
                    pr = { "Gemstone": $('.product__title h1').text() }
                }
                items.push({ 
                    id: parseInt(variationId), 
                    quantity: 1,
                    properties: pr
                });
            }
            if($('#ev_certification').val() != null && $('#ev_certification').val() != '' ){
                items.push({
                    id: parseInt(52060630188350),
                    quantity: 1,
                });
            }
        } 
        if(items.length > 0){
            fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ items: items })
            }).then((res) => res.json()).then((data) => {
                console.log(data);
                if (data?.status === 422 || data?.status === 'bad_request') {
                    alert(data?.message);
                }else{
                    window.location.href = '/cart'; 
                }
            }).catch((err) => {
                console.error('Cart error:', err);
                alert("Something went wrong adding to cart.");
            }); 
        } else {
            alert("Something went wrong adding to cart, Please select the products.");
        }
    });


    const sizeOptions = {
        indian: [
          "1","2","3","4","5","6","7","8","9","10",
          "11","12","13","14","15","16","17","18","19","20",
          "21","22","23","24","25","26","27","28","29","30",
          "31","32","33","34","35","36"
        ],
        us: [
          "0","¼","½","¾","1","1¼","1½","1¾","2","2¼","2½","2¾",
          "3","3¼","3½","3¾","4","4¼","4½","4¾","5","5¼","5½","5¾",
          "6","6¼","6½","6¾","7","7¼","7½","7¾","8","8¼","8½","8¾",
          "9","9¼","9½","9¾","10","10¼","10½","10¾","11","11¼","11½","11¾",
          "12","12¼","12½","12¾","13","13¼","13½","13¾","14","14¼","14½","14¾",
          "15","15¼","15½","15¾","16"
        ],
        uk: [
          "A","A½","B","B½","C","C½","D","D½","E","E½","F","F½",
          "G","G½","H","H½","I","J","J½","K","K½","L","L½",
          "M","M½","N","N½","O","O½","P","P½","Q","Q½",
          "R","R½","S","S½","T","T½","U","U½","V","V½",
          "W","W½","X","X½","Y","Z","Z½","Z1","Z2","Z3","Z4"
        ],
        adjustable: ["We'll send you a free ring sizer!"]
    };

    const sizeSystemSelect = document.getElementById("ev_ring_system");
    const ringSizeSelect = document.getElementById("ev_ring_size");

    sizeSystemSelect.addEventListener("change", function() {
        const selectedSystem = this.value;

        // Reset ring size dropdown
        ringSizeSelect.innerHTML = '<option disabled selected value="">-- Please Select --</option>';

        // Populate options based on selection
        if (sizeOptions[selectedSystem]) {
        sizeOptions[selectedSystem].forEach(size => {
            const option = document.createElement("option");
            option.value = size;
            option.textContent = size;
            ringSizeSelect.appendChild(option);
        });
        }
    });

    $(document).on('click', '.design-item', function(){
        $('.ev-select-rp img').attr('src', $(this).data('image'));
        $('.ev-select-rp .box-1 p').text($(this).data('txt'));
        $('.ev-select-rp .box-2 span').text($(this).data('value'));
        $('.ev-select-rp').show();
        $('#design-options').hide();
    });

    $(document).on('click', '.ev-select-rp .box-2 a', function(){
        $('.ev-select-rp').hide();
        $('#design-options').show();
    });

});


$(document).ready(function () {
    function createPopup(imageUrl, e) {
      if ($('#swatch-popup').length) return;

      const popup = $('<div id="swatch-popup"></div>').css({
        position: 'absolute',
        top: e.pageY + 10,
        left: e.pageX + 10,
        padding: '5px',
        background: '#fff',
        border: '1px solid #ccc',
        'z-index': 9999,
        'box-shadow': '0 2px 10px rgba(0,0,0,0.2)',
      }).append(`<img src="${imageUrl}" style="max-width:250px; max-height:250px;">`);

      $('body').append(popup);
    }

    function getImageUrl($el) {
      const backgroundStyle = $el.attr('style');
      const imageUrlMatch = backgroundStyle?.match(/url\(([^)]+)\)/);
      if (imageUrlMatch) {
        return imageUrlMatch[1].replace(/([&?])width=\d+/, '');
      }
      return null;
    }

    $(document).on('pointerenter', '#design-options .design-item', function (e) {
      if (e.pointerType !== 'mouse') return;
      const imageUrl = getImageUrl($(this).find('.design-item-image'));
      if (imageUrl) createPopup(imageUrl, e);
    });

    $(document).on('pointerleave', '#design-options .design-item', function (e) {
      if (e.pointerType !== 'mouse') return;
      $('#swatch-popup').remove();
    });

    $(document).on('pointermove', '#design-options .design-item', function (e) {
      if (e.pointerType !== 'mouse') return;
      $('#swatch-popup').css({
        top: e.pageY + 10,
        left: e.pageX + 10
      });
    });

    $(document).on('click', '#design-options .design-item', function (e) {
      e.stopPropagation();
      if ($('#swatch-popup').length) {
        $('#swatch-popup').remove();
      } else {
        const imageUrl = getImageUrl($(this));
        if (imageUrl) createPopup(imageUrl, e);
      }
    });

    $(document).on('click', function (e) {
      if (!$(e.target).closest('#design-options .design-item, #swatch-popup').length) {
        $('#swatch-popup').remove();
      }
    });
  });